import { Link } from "@mui/material";
import React, { useState } from "react";
import styles from "../components/laymanComp_css/LaymanPage2.module.css";
import MembershipModal from "../../../components/Modal/MembershipModal";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/rotaWheel.json";

export default function LaymanPage2() {


  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };

  return (
    <>
     <Common_html BlockData={BlockData} />




    {/* <MembershipModal
    membershipOpen={membershipOpen}
    setMembershipOpen={setMembershipOpen}
    /> */}
    </>
  );
}
